
export enum BackendErrorCode {
  NotValidEmail= 'NotValidEmail',
  WeakPassword= 'WeakPassword',
  InvalidEnumValue= 'InvalidEnumValue',
  InvalidUUID= 'InvalidUUID',
  InvalidJWT= 'InvalidJWT',
  InvalidDate= 'InvalidDate',
  InvalidBoolean= 'InvalidBoolean',
  InvalidLength= 'InvalidLength',
  IsNotTrue= 'IsNotTrue',
  NotAString= 'NotAString',
  EmptyString= 'EmptyString',
  InvalidPhoneNumber= 'InvalidPhoneNumber',
  NumberTooSmallThanRelated= 'NumberTooSmallThanRelated',
  NumberTooBigThanRelated= 'NumberTooBigThanRelated',
  NotAWorkingDay= 'NotAWorkingDay',
  PropertyShouldNotExists= 'PropertyShouldNotExists',
  InvalidBidAmount= 'InvalidBidAmount',
  InvalidPropertyByRules= 'InvalidPropertyByRules',
  InvalidBusDossierImageName= 'InvalidBusDossierImageName',
  InvalidBusDossierDamageImageName= 'InvalidBusDossierDamageImageName',
  InvalidBusAssetVideoName= 'InvalidBusAssetVideoName',
  TrustReportTypeImmutable= 'TrustReportTypeImmutable',
  AssetCoverImageMissing= 'AssetCoverImageMissing',
  AssetMissingAtLeastOneImage= 'AssetMissingAtLeastOneImage',
  EmailAlreadyInUse= 'EmailAlreadyInUse',
  InvalidAuctionState= 'InvalidAuctionState',
  BFAAlreadyExistsForVersion= 'BFAAlreadyExistsForVersion',
  VersionNameAlreadyExistsForModel= 'VersionNameAlreadyExistsForModel',
  InvalidParameters= 'InvalidParameters',
  SalesRepMustHavePhoneNumber= 'SalesRepMustHavePhoneNumber',
  OTPCodeNotValid= 'OTPCodeNotValid',
  TinMustBeFilled= 'TinMustBeFilled',
  BusinessNameMustBeFilled= 'BusinessNameMustBeFilled',
  OtpExpiredOrNotFound= 'OtpExpiredOrNotFound',
  OtpEmailAlreadyVerified= 'OtpEmailAlreadyVerified',
  OtpMaxAttemptsExceeded= 'OtpMaxAttemptsExceeded',
  OtpResendTooSoon= 'OtpResendTooSoon',
  OtpAccountLocked= 'OtpAccountLocked',
  PrismaError= 'PrismaError',
  EntityNotFound= 'EntityNotFound',
  EntityAlreadyExists= 'EntityAlreadyExists',
  SignupUserAlreadyExists= 'SignupUserAlreadyExists',
  SignupCompanyWithSamePecAlreadyExists= 'SignupCompanyWithSamePecAlreadyExists',
  OnboardingAlreadyCompleted= 'OnboardingAlreadyCompleted',
  OnboardingCompanyMismatch= 'OnboardingCompanyMismatch',
  UserAlreadyAssociatedToACompany= 'UserAlreadyAssociatedToACompany',
  VexatiousClausesNotAccepted= 'VexatiousClausesNotAccepted',
  CompanyBanned= 'CompanyBanned',
  AuthAuthenticationVersionMismatch= 'AuthAuthenticationVersionMismatch',
  AuthNoAdminByEmail= 'AuthNoAdminByEmail',
  AuthNoUserByEmail= 'AuthNoUserByEmail',
  AuthTokenExpired= 'AuthTokenExpired',
  AuthTokenNotSubmitted= 'AuthTokenNotSubmitted',
  AuthTokenNotValid= 'AuthTokenNotValid',
  AuthWrongPassword= 'AuthWrongPassword',
  PasswordDoNotMatch= 'PasswordDoNotMatch',
  ActionRequiresCompany= 'ActionRequiresCompany',
  AuthDossierAgentAppOnly= 'AuthDossierAgentAppOnly',
  AuthEmailNotVerified= 'AuthEmailNotVerified',
  AuthNotEnoughPermission= 'AuthNotEnoughPermission',
  ForbiddenRequest= 'ForbiddenRequest',
  UserIsBanned= 'UserIsBanned',
  UserWithoutConsent= 'UserWithoutConsent',
  BailNotAuthorized= 'BailNotAuthorized',
  BailCantVoid= 'BailCantVoid',
  GenericError= 'GenericError',
  ServiceUnavailable= 'ServiceUnavailable',
  UserHasNoCompany= 'UserHasNoCompany',
  AdminUserProfileImageNotFound= 'AdminUserProfileImageNotFound',
  UploadFileError= 'UploadFileError',
  InvalidCaptcha= 'InvalidCaptcha',
  MissingCaptcha= 'MissingCaptcha',
  AuctionExpired= 'AuctionExpired',
  AuctionNotRunning= 'AuctionNotRunning',
  AuctionClearingPriceNotSettable= 'AuctionClearingPriceNotSettable',
  AuctionInitialExpiresAtInvalid= 'AuctionInitialExpiresAtInvalid',
  AuctionInvalidMainAssetId= 'AuctionInvalidMainAssetId',
  AuctionUpdateDenied= 'AuctionUpdateDenied',
  AuctionRelistBlockedByDomain= 'AuctionRelistBlockedByDomain',
  AuctionOneEuroStartingPriceMustBeOneEuro= 'AuctionOneEuroStartingPriceMustBeOneEuro',
  AuctionMinMarketPriceRequired= 'AuctionMinMarketPriceRequired',
  AuctionMinMarketPriceMustBeGreaterThanStartingPrice= 'AuctionMinMarketPriceMustBeGreaterThanStartingPrice',
  AuctionStartingPriceInvalid= 'AuctionStartingPriceInvalid',
  AuctionSellerReservePriceInvalid= 'AuctionSellerReservePriceInvalid',
  AuctionBidStepInvalid= 'AuctionBidStepInvalid',
  AuctionReservePriceNotMultipleOfStep= 'AuctionReservePriceNotMultipleOfStep',
  AuctionSellerReservePriceNotMultipleOfStep= 'AuctionSellerReservePriceNotMultipleOfStep',
  AuctionBailAmountNotMultipleOfStep= 'AuctionBailAmountNotMultipleOfStep',
  MainAssetWithoutBusAsset= 'MainAssetWithoutBusAsset',
  AuctionNoBusAsset= 'AuctionNoBusAsset',
  InvalidDirectSaleState= 'InvalidDirectSaleState',
  RequirementsNotMeetToChangeState= 'RequirementsNotMeetToChangeState',
  DirectSaleUpdateDenied= 'DirectSaleUpdateDenied',
  CantBuyDirectSaleNotOpen= 'CantBuyDirectSaleNotOpen',
  DirectSalePriceOnRequest= 'DirectSalePriceOnRequest',
  CantBuyDirectSaleOrderNotPaid= 'CantBuyDirectSaleOrderNotPaid',
  CantBuyDirectSaleHasDirectSaleOrder= 'CantBuyDirectSaleHasDirectSaleOrder',
  CantBuyPendingBail= 'CantBuyPendingBail',
  UserHasMoreThanOneActiveDirectSaleOrder= 'UserHasMoreThanOneActiveDirectSaleOrder',
  DirectSaleHasOpenNegotiations= 'DirectSaleHasOpenNegotiations',
  DealerSaleAssetsHaveOpenNegotiations= 'DealerSaleAssetsHaveOpenNegotiations',
  InvalidUserForOrderDetail= 'InvalidUserForOrderDetail',
  CantPerformUserCompanyEqSellerCompany= 'CantPerformUserCompanyEqSellerCompany',
  CantPerformScrapSaleNotScrapyardCompany= 'CantPerformScrapSaleNotScrapyardCompany',
  CantPerformCompanyNotYetApprovedForScrap= 'CantPerformCompanyNotYetApprovedForScrap',
  CantPerformCompanyNotApprovedForScrap= 'CantPerformCompanyNotApprovedForScrap',
  CantPerformCompanyUnderReview= 'CantPerformCompanyUnderReview',
  CantPerformUnapprovedCompany= 'CantPerformUnapprovedCompany',
  CantPerformBannedCompany= 'CantPerformBannedCompany',
  CantPerformBadUserCompany= 'CantPerformBadUserCompany',
  CantPerformUserWithoutCompany= 'CantPerformUserWithoutCompany',
  CantPerformUserNoBail= 'CantPerformUserNoBail',
  CantPerformPurchase= 'CantPerformPurchase',
  CantPerformInspectionExpiredNotExportable= 'CantPerformInspectionExpiredNotExportable',
  CantPerformInspectionExpiringSoonNotExportable= 'CantPerformInspectionExpiringSoonNotExportable',
  SaleAssetCongruenceMismatch= 'SaleAssetCongruenceMismatch',
  AssetAlreadyForSale= 'AssetAlreadyForSale',
  AssetNotFound= 'AssetNotFound',
  InvalidUrlKeyValue= 'InvalidUrlKeyValue',
  CantBidAuctionIsNotRunning= 'CantBidAuctionIsNotRunning',
  CantBidUserWithAutoBidActive= 'CantBidUserWithAutoBidActive',
  BidScenarioNotSupported= 'BidScenarioNotSupported',
  BidScenarioNotConfigured= 'BidScenarioNotConfigured',
  CantBidUnhandledScenario= 'CantBidUnhandledScenario',
  InvalidAutoBidAmount= 'InvalidAutoBidAmount',
  InvalidAutoBidId= 'InvalidAutoBidId',
  CantAutoBid= 'CantAutoBid',
  BidNotCreated= 'BidNotCreated',
  InvalidUserAutoBid= 'InvalidUserAutoBid',
  InvalidAuctionAutoBid= 'InvalidAuctionAutoBid',
  UnexpectedAutoBidData= 'UnexpectedAutoBidData',
  PaymentProviderError= 'PaymentProviderError',
  WinningBidNotFound= 'WinningBidNotFound',
  CountryCodeNotFound= 'CountryCodeNotFound',
  VatNumberNotFound= 'VatNumberNotFound',
  NegotiationBuyerProposalNotValid= 'NegotiationBuyerProposalNotValid',
  NegotiationSellerProposalNotValid= 'NegotiationSellerProposalNotValid',
  NegotiationNotOpen= 'NegotiationNotOpen',
  NegotiationStateInvalid= 'NegotiationStateInvalid',
  NegotiationInvalidParticipant= 'NegotiationInvalidParticipant',
  NegotiationProposalNotFound= 'NegotiationProposalNotFound',
  NegotiationNextParticipantNotFound= 'NegotiationNextParticipantNotFound',
  NegotiationAuctionIsRelistsAncestor= 'NegotiationAuctionIsRelistsAncestor',
  DirectSaleNegotiationRequestNotValid= 'DirectSaleNegotiationRequestNotValid',
  RelatedParamsInvalid= 'RelatedParamsInvalid',
  CompanyInfoNotFound= 'CompanyInfoNotFound',
  CompanyIncompleteForInvoicing= 'CompanyIncompleteForInvoicing',
  CompanyMainMemberCannotBeApproved= 'CompanyMainMemberCannotBeApproved',
  MainMemberAlreadyPresent= 'MainMemberAlreadyPresent',
  LogisticsServiceDestinationCountryNotSupported= 'LogisticsServiceDestinationCountryNotSupported',
  LogisticsServiceUnsupportedVehicleType= 'LogisticsServiceUnsupportedVehicleType',
  LogisticsServiceAddressNotPriceable= 'LogisticsServiceAddressNotPriceable',
  LogisticsServiceRouteNotServiceable= 'LogisticsServiceRouteNotServiceable',
  LogisticsServiceRequiresAlternativeTransport= 'LogisticsServiceRequiresAlternativeTransport',
  LogisticsServiceRouteNotFound= 'LogisticsServiceRouteNotFound',
  ValueAddedServiceNotFound= 'ValueAddedServiceNotFound',
  ValueAddedServiceNotSupported= 'ValueAddedServiceNotSupported',
  InvoiceNotFound= 'InvoiceNotFound',
  NetSuiteInvoiceUpdateBlocked= 'NetSuiteInvoiceUpdateBlocked',
  NetSuiteCreditMemoNotAllowed= 'NetSuiteCreditMemoNotAllowed',
  NetSuiteCreditMemoAlreadyExists= 'NetSuiteCreditMemoAlreadyExists',
  TaxCodeAlreadyExists= 'TaxCodeAlreadyExists',
  InvalidTaxCodeOriginCombination= 'InvalidTaxCodeOriginCombination',
  BusAssetMissingLicensePlace= 'BusAssetMissingLicensePlace',
  DocumentNotAllowedForCountry= 'DocumentNotAllowedForCountry',
  MultipleWhatsappEnabledNumbersForAdmin= 'MultipleWhatsappEnabledNumbersForAdmin',
  DepotTermsNotAccepted= 'DepotTermsNotAccepted',
  DepotServiceModificationDenied= 'DepotServiceModificationDenied',
  PublicationApprovalTokenInvalid= 'PublicationApprovalTokenInvalid',
  PublicationApprovalNotFound= 'PublicationApprovalNotFound',
  PublicationApprovalPriceMismatch= 'PublicationApprovalPriceMismatch',
  PublicationApprovalUserMismatch= 'PublicationApprovalUserMismatch',
  PublicationApprovalAlreadyApproved= 'PublicationApprovalAlreadyApproved',
  PublicationApprovalDuplicateItems= 'PublicationApprovalDuplicateItems',
  PublicationApprovalMissingVin= 'PublicationApprovalMissingVin',
  DirectSalePriceNotLower= 'DirectSalePriceNotLower',
  DirectSalePriceReductionNotAllowed= 'DirectSalePriceReductionNotAllowed',
  AiTranslationError= 'AiTranslationError',
  CompanyGroupNotEmpty= 'CompanyGroupNotEmpty',
  CountryVatInfoInUse= 'CountryVatInfoInUse',

}